/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adm_Err_Session_RequiredInputs */

const en_adm_err_session_required = /** @type {(inputs: Adm_Err_Session_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in again to do this. API tokens cannot change access.`)
};

const de_adm_err_session_required = /** @type {(inputs: Adm_Err_Session_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melde dich erneut an, um das zu tun. API-Tokens können Zugriffe nicht ändern.`)
};

/**
* | output |
* | --- |
* | "Sign in again to do this. API tokens cannot change access." |
*
* @param {Adm_Err_Session_RequiredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const adm_err_session_required = /** @type {((inputs?: Adm_Err_Session_RequiredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adm_Err_Session_RequiredInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_adm_err_session_required(inputs)
	return en_adm_err_session_required(inputs)
});